import 'isomorphic-fetch'

import { checkHttpStatus, getApiBaseUrlWithOrg } from '../utils'
import { createCompiledQuest, closeToQualityReviewModal } from './review'

export const SET_APPROVED_SUCCESS = 'SET_APPROVED_SUCCESS'
export const DELETE_APPROVED_SUCCESS = 'DELETE_APPROVED_SUCCESS'
export const IS_EDITING_APPROVAL = 'IS_EDITING_APPROVAL'
export const IS_SETTING_LAST_APPROVAL = 'IS_SETTING_LAST_APPROVAL'

export function setApprovedSuccess(response) {
  return {
    type: SET_APPROVED_SUCCESS,
    payload: {
      approval: response
    }
  }
}

export function deleteApprovedSuccess(approvalId) {
  return {
    type: DELETE_APPROVED_SUCCESS,
    payload: {
      approvalId: approvalId
    }
  }
}

export function isEditingApproval() {
  return {
    type: IS_EDITING_APPROVAL
  }
}

export function isSettingLastApproval() {
  return {
    type: IS_SETTING_LAST_APPROVAL
  }
}

export function setApproved(questId, criteria) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/approvals`
    dispatch(isEditingApproval())

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'POST',
          headers: {
            Authorization: `Token token="${state.user.token}"`,
            Accept: 'application/json, application/vnd.oefngl.v1',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            approval: {
              criteria: criteria
            }
          })
        })
      )
      const json = await response.json()
      await dispatch(setApprovedSuccess(json))
    } catch (error) {
      console.log(error)
    }
  }
}

export function setLastApproval(questId, criteria) {
  return async dispatch => {
    await Promise.all([
      dispatch(isSettingLastApproval()),
      dispatch(setApproved(questId, criteria)),
      dispatch(createCompiledQuest(questId))
    ]).then(() => dispatch(closeToQualityReviewModal()))
  }
}

export function deleteApproval(questId, approvalId) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/approvals/${approvalId}`
    dispatch(isEditingApproval())

    try {
      checkHttpStatus(
        await fetch(url, {
          method: 'DELETE',
          headers: {
            Authorization: `Token token="${state.user.token}"`,
            Accept: 'application/json, application/vnd.oefngl.v1',
            'Content-Type': 'application/json'
          }
        })
      )
      dispatch(deleteApprovedSuccess(approvalId))
    } catch (error) {
      console.log(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/approval.js